import { LINEUP_BASE_CLASS, LINEUPS_BASE_CLASS } from "../constants.js";

export default class LocationSearchLineups {
  constructor(container, store, eventBus) {
    this.container = container;
    this.store = store;
    this.eventBus = eventBus;

    this.lineUpsElement = this.container?.querySelector(`.${LINEUPS_BASE_CLASS}__lineups`);
    this.lineUpElements = this.container
      ? this.container.querySelectorAll(`.${LINEUP_BASE_CLASS}`)
      : [];
    this.labelElement = this.container?.querySelector(`.${LINEUPS_BASE_CLASS}__filter-label`);

    this.addEventListeners();
    this.addButtonClickHandlers();
    this.render();
  }

  addEventListeners() {
    this.eventBus.on("locationTypeFiltersChanged", () => this.render(true));
    this.eventBus.on("locationMinimumCapacityChanged", () => this.render());
  }

  addButtonClickHandlers() {
    this.lineUpElements.forEach((lineupElement) => {
      lineupElement.addEventListener("click", (e) => this.onLineupElementClick(e));
    });

    if (this.labelElement) {
      this.labelElement.addEventListener("click", () => this.toggleLineupsVisibility());
    }
  }

  toggleLineupsVisibility() {
    this.lineUpsElement?.classList.toggle("d-none");
    const arrow = this.labelElement.querySelector(".location-search__lineup-arrow");
    arrow?.classList.toggle("location-search__lineup-arrow--active");
  }

  render(reset = false) {
    this.toggleContainerVisibility();

    if (reset) this.resetLineupSelections();

    const venueCapacities = this.store.getVenueCapacities();
    const layoutNames = venueCapacities.map((vc) => vc["venue-layout"]);

    this.updateLineupElements(layoutNames, venueCapacities);
  }

  toggleContainerVisibility() {
    this.container?.classList.toggle("d-none", !this.store.activeTypeValue);
  }

  resetLineupSelections() {
    this.lineUpElements.forEach((lineupElement) => {
      lineupElement.dataset.selected = "0";
    });
  }

  updateLineupElements(layoutNames, venueCapacities) {
    this.lineUpElements.forEach((lineupElement) => {
      const { venueValue } = lineupElement.dataset;

      const isSelectable = this.isLineupSelectable(venueValue, layoutNames, venueCapacities);
      lineupElement.setAttribute("data-selectable", isSelectable);

      lineupElement.dataset.selected = 
        this.store.selectedLineup === venueValue ? "1" : "0";
    });
  }

  isLineupSelectable(venueValue, layoutNames, venueCapacities) {
    if (layoutNames.includes(venueValue)) {
      const foundLayout = venueCapacities.find((vc) => vc["venue-layout"] === venueValue);
      if (foundLayout) {
        const neededCap = parseInt(foundLayout["venue-layout-capacity"], 10);
        return this.store.minimumCapacity <= neededCap;
      }
    }
    return false;
  }

  onLineupElementClick(event) {
    const lineupElement = event.currentTarget;
    const venueValue = lineupElement.dataset.venueValue;
    this.store.setSelectedLineup(venueValue);
    this.render();
  }
}